// components/ResizableHeader.js
import React from 'react';

const ResizableHeader = ({ title, width, onResize }) => {
  const handleMouseDown = (e) => {
    const startX = e.clientX;
    const startWidth = width;

    const handleMouseMove = (eMove) => {
      const newWidth = startWidth + (eMove.clientX - startX);
      if (newWidth > 60) {
        onResize(newWidth);
      }
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <div style={{ position: 'relative', height: '100%', padding: '0 10px' }}>
      <div style={{ padding: '6px 0' }}>{title}</div>
      <div
        onMouseDown={handleMouseDown}
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          height: '100%',
          width: '5px',
          cursor: 'col-resize',
          backgroundColor: 'transparent',
        }}
      />
    </div>
  );
};

export default ResizableHeader;
